import {createSelector} from 'reselect';
import page from '../../../page/page';
import Track from '../../../utils/tracking';
import {getSettings} from '../../selectors';
import getIsAdyenV2Enabled from '../AdyenV2/getIsAdyenV2Enabled';
import getIsInApmExperimentVariant1 from './getIsInApmExperimentVariant1';
import getIsInApmExperimentVariant2 from './getIsInApmExperimentVariant2';
import getIsInApmExperimentVariant3 from './getIsInApmExperimentVariant3';
import doMetric from '../../../tracking/bigQueryMetricRecorder';
import getIsInApmExperimentWave3Variant1 from './getIsInApmExperimentWave3Variant1';

const recordMetric = (isInAPM, reason = '') => {
  try {
    doMetric('apmExperiment', [{name: 'isInExperiment', value: isInAPM}, {name: 'reason', value: reason}], [], 'impression');
  } catch (e) {
    Track.track(e);
  }
};

export const getIsInApmExperiment = createSelector(
  [getIsInApmExperimentVariant1, getIsInApmExperimentVariant2, getIsInApmExperimentVariant3, getIsInApmExperimentWave3Variant1, getSettings, getIsAdyenV2Enabled],
  (isVariant1, isVariant2, isVariant3, isVariant4, settings, isAdyenV2Enabled) => {
    if (isAdyenV2Enabled) {
      recordMetric(false, 'AdyenV2Enabled');
      return false;
    }
  
    if (!page.isOnPage('checkout')) {
      recordMetric(false, 'NotOnCheckoutPage');
      return false;
    }
    
    if ((isVariant1 || isVariant2 || isVariant3 || isVariant4)) {
      if (settings?.apm_payment_option_to_category_map) {
        recordMetric(true);
        return true;
      }

      Track.error('APM experiment error: apm_payment_option_to_category_map does not exist in settings');
  
      recordMetric(false, 'CategorySettingMissing');
      
      return false;
    }
  
    recordMetric(false, 'NotInAnyVariant');
    
    return false;
  },
);

export default getIsInApmExperiment;
